import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputRangeDirective } from '../../directives/input-range.directive';
import { FormsModule } from '@angular/forms';
import { Observable, Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-input-spinner',
  standalone: true,
  imports: [InputRangeDirective, FormsModule],
  templateUrl: './input-spinner.component.html',
  styleUrl: './input-spinner.component.scss'
})
export class InputSpinnerComponent {
  @Input({ required: true }) model: number;
  @Input({ required: true }) name: string;
  @Input() class: string | string[] = '';
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;

  @Output() modelChange = new EventEmitter<number>()

  numbers: Observable<number> = interval(200);
  subscriber!: Subscription;

  dec() {
    this.model = Math.max(this.min, this.model - this.step);
    this.modelChange.emit(this.model);
  }

  inc() {
    this.model = Math.min(this.max, this.model + this.step);
    this.modelChange.emit(this.model);
  }
}
